import React from "react";
import "./ResultBox.css";
import alert_warn from "../assets/alert_warn.svg";
import alert_success from "../assets/alert_success.svg";
import alert_info from "../assets/alert_info.svg";


function ResultBox({ result }) {

  function getResultBoxClass(result) {
    switch (result) {
      case "success":
        return "result-box success-box";
      case "failure":
        return "result-box failure-box";
      case "warn":
      case "expired":
        return "result-box warn-box";
      default:
        return "result-box";
    }
  }

  function getResultIcon(result) {
    switch (result) {
      case "success":
        return alert_success;
      case "failure":
      case "warn":
      case "expired":
        return alert_warn;
      default:
        return alert_info;
    }
  }

  function getResultText(result) {
    switch (result) {
      case "success":
        return "The number is verified.";
      case "failure":
        return "Verification failed";
      case "warn":
        return <div>Error during verification.<br />Please ensure wi-fi is switched off and retry.</div>;
      case "expired":
        return <div>The page has expired due to inactivity.<br />Please click on New Verification to resume the process.</div>;
      default:
        return "Unexpected error";
    }
  }

  function getResultTextClass(result) {
    switch (result) {
      case "success":
        return "alert-text success-text";
      case "failure":
        return "alert-text failure-text";
      case "warn":
        case "expired":
        return "alert-text warn-text";
      default:
        return "alert-text";
    }
  }

  return (
    <div className={getResultBoxClass(result)}>
      <img className="alert-icon" src={getResultIcon(result)} alt="alert-box-icon" />
      <div className={getResultTextClass(result)}>{getResultText(result)}</div>
    </div>
  );
}

export default React.memo(ResultBox);
